module.exports = "<section class=\"static-list\">\n\t<h1>{{ title }}</h1>\n\t<ul>\n\t\t<li *ngFor=\"let item of items\">{{ item }}</li>\n\t</ul>\n</section>\n"